import { render } from "./LearningGoalsAll.vue?vue&type=template&id=a911c20c"
import script from "./LearningGoalsAll.vue?vue&type=script&lang=js"
export * from "./LearningGoalsAll.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__